module.exports = __webpack_public_path__ + "img/Systemconstructionselect.bbf41960.svg";